// extracted by mini-css-extract-plugin
module.exports = {"date":"DateInput_date__19InR","input":"DateInput_input__1cRT5","calender":"DateInput_calender__1OcVA"};